import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ReviewsSection = ({ reviews, averageRating, totalReviews }) => {
  const [sortBy, setSortBy] = useState('recent');

  const renderStars = (rating) => {
    return (
      <div className="flex items-center gap-1">
        {[1, 2, 3, 4, 5]?.map((star) => (
          <Icon
            key={star}
            name="Star"
            size={16}
            color="#FFA500"
            fill="#FFA500"
          />
        ))}
      </div>
    );
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  return (
    <div className="p-6 md:p-8 rounded-xl bg-card border border-border">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-accent/10 border border-accent/30 flex items-center justify-center">
            <Icon name="MessageSquare" size={20} color="var(--color-accent)" />
          </div>
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground">
              Customer Reviews
            </h2>
            <div className="flex items-center gap-2 mt-1">
              {renderStars(5)}
              <span className="text-sm text-muted-foreground caption">
                5.0 out of 5 ({totalReviews} reviews)
              </span>
            </div>
          </div>
        </div>

        <select
          value={sortBy}
          onChange={(e) => setSortBy(e?.target?.value)}
          className="px-4 py-2 rounded-lg bg-muted border border-border text-foreground cursor-pointer transition-all duration-250 hover:border-primary focus:outline-none focus:border-primary"
        >
          <option value="recent">Most Recent</option>
          <option value="helpful">Most Helpful</option>
          <option value="highest">Highest Rating</option>
          <option value="lowest">Lowest Rating</option>
        </select>
      </div>
      <div className="space-y-4">
        {reviews?.map((review) => (
          <div
            key={review?.id}
            className="p-6 rounded-lg bg-muted/50 border border-border space-y-4"
          >
            <div className="flex items-start justify-between gap-4">
              <div className="flex items-start gap-3 flex-1">
                <Image
                  src={review?.avatar}
                  alt={review?.avatarAlt}
                  className="w-12 h-12 rounded-lg object-cover"
                />
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="font-semibold text-foreground">
                      {review?.name}
                    </span>
                    {review?.verified && (
                      <div className="flex items-center gap-1 px-2 py-0.5 rounded bg-success/10 border border-success/30">
                        <Icon name="CheckCircle2" size={12} color="var(--color-success)" />
                        <span className="text-xs text-success caption">Verified</span>
                      </div>
                    )}
                  </div>
                  <div className="flex items-center gap-3">
                    {renderStars(5)}
                    <span className="text-sm text-muted-foreground caption">
                      {formatDate(review?.date)}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <p className="text-base text-foreground leading-relaxed">
              {review?.comment}
            </p>

            <div className="flex items-center gap-4 pt-2">
              <button className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-card border border-border transition-all duration-250 hover:bg-primary/10 hover:border-primary">
                <Icon name="ThumbsUp" size={16} color="var(--color-primary)" />
                <span className="text-sm text-foreground caption">
                  Helpful ({review?.helpful})
                </span>
              </button>
              <button className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-card border border-border transition-all duration-250 hover:bg-error/10 hover:border-error">
                <Icon name="ThumbsDown" size={16} color="var(--color-muted-foreground)" />
                <span className="text-sm text-foreground caption">
                  Not Helpful ({review?.notHelpful})
                </span>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReviewsSection;